import { NoticeFactory } from '@b2b/common/factories/notice';
import { ApiService } from '@b2b/common/services/api/types';
import { TODO } from '@b2b/types/core/utils';
import uiRouter, { StateService } from '@uirouter/angularjs';
import angular, { IScope } from 'angular';

HomeController.$inject = ['$scope', '$state', 'AuthService', 'ApiService', 'ValidateService', 'NoticeFactory'];

function HomeController(
  $scope: IScope & { home: TODO },
  $state: StateService,
  AuthService: TODO,
  ApiService: ApiService,
  ValidateService: TODO,
  NoticeFactory: NoticeFactory
) {
  const ctrl = {
    isSubmitted: false,

    model: {
      email: '',
      orgName: '',
    },

    notice: new NoticeFactory(),

    init: function () {
      var state = AuthService.getRedirectState();

      if (state) {
        $state.go(state);
      }

      ctrl.notice = new NoticeFactory();
    },

    isValidEmail: function () {
      if (ctrl.isSubmitted) {
        return ValidateService.validate([{ email: ctrl.model.email }]);
      }
    },

    isValidCompany: function () {
      if (ctrl.isSubmitted) {
        return ValidateService.validate([{ len: { value: ctrl.model.orgName } }, { notEmail: ctrl.model.orgName }]);
      }
    },

    showForm: function () {
      return (!ctrl.notice.isLoading && !ctrl.notice.isLoaded) || ctrl.notice.showErrors;
    },

    showDone: function () {
      return ctrl.notice.isLoaded && !ctrl.notice.showErrors;
    },

    done: function () {
      $state.go('login.default');
    },

    complete: function () {
      ctrl.isSubmitted = true;

      if (
        ValidateService.validate([
          { len: { value: ctrl.model.orgName } },
          { notEmail: ctrl.model.orgName },
          { email: ctrl.model.email },
        ])
      ) {
        ctrl.notice.startLoad();
        ApiService.tenant
          .create(ctrl.model)
          .then((response) => ctrl.success(response))
          .catch((response) => ctrl.error(response));
      } else {
        ctrl.notice.showErrorMessages([{ message: 'Please correct the errors below.' }]);
      }
    },

    success: function (response) {
      ctrl.notice.endLoad();
      ctrl.notice.hideMessages();
    },

    error: function (response) {
      ctrl.notice.endLoad();
      ctrl.notice.showErrorMessages([{ message: response.data.error }]);
    },
  };

  $scope.home = ctrl;
  ctrl.init();
}

export const HomeControllerModule = angular
  .module('acme.view.home.controllers', [
    uiRouter,
    'acme.common.service.auth',
    'acme.common.service.api',
    'acme.common.service.validate',
    'acme.common.factory.notice',
  ])
  .controller('HomeController', HomeController).name;
